if (!customElements.get('popular-products')) {
  customElements.define('popular-products', class PopularProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-popular-track]');
      this.previous = this.querySelector('[data-popular-previous]');
      this.next = this.querySelector('[data-popular-next]');
      this.current = this.querySelector('[data-popular-current]');
      this.total = this.querySelector('[data-popular-total]');
      if (!this.track) return;
      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      this.track.addEventListener('click', (event) => this.handleVariantClick(event));
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    handleVariantClick(event) {
      if (!(event.target instanceof Element)) return;
      const option = event.target.closest('[data-popular-content-option]');
      if (!option) return;

      const card = option.closest('[data-popular-variant-card]');
      if (!card) return;

      let variants = [];
      try {
        variants = JSON.parse(card.querySelector('[data-popular-variants]')?.textContent || '[]');
      } catch (_error) {
        return;
      }

      const matches = variants.filter((variant) => variant.contentValue === option.dataset.popularContentOption);
      const variant = matches.find((item) => item.available) || matches[0];
      if (!variant) return;

      card.querySelectorAll('[data-popular-content-option]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === option));
      });

      const price = card.querySelector('[data-popular-price] strong');
      const comparePrice = card.querySelector('[data-popular-price] s');
      const stock = card.querySelector('[data-popular-stock]');
      const variantLink = card.querySelector('[data-popular-variant-link]');
      const variantUrl = `${variantLink?.dataset.productUrl || ''}?variant=${variant.id}`;

      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.comparePrice || '';
        comparePrice.hidden = !variant.comparePrice;
      }
      if (stock) {
        stock.textContent = variant.available ? stock.dataset.inStockLabel : stock.dataset.soldOutLabel;
        stock.classList.toggle('is-sold-out', !variant.available);
      }
      card.querySelectorAll('[data-popular-product-link]').forEach((link) => { link.href = variantUrl; });
      if (variantLink) variantLink.href = variantUrl;

    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }

    move(direction) {
      const card = this.track.querySelector('.popular-product-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || 0);
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    requestUpdate() {
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateControls());
    }

    updateControls() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const card = this.track.querySelector('.popular-product-card');
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || 0);
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      const total = this.track.querySelectorAll('.popular-product-card').length;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;
      const current = atEnd ? total : Math.min(total, Math.max(1, Math.round(this.track.scrollLeft / step) + 1));
      if (this.current) this.current.textContent = current;
      if (this.total) this.total.textContent = total;
      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  });
}
